import {disableTextSelection, calculateObjectCoords} from "../atBrowserUtils"

export default class SelectionVeil {
    constructor(animationImages, wrapperElement){
        this.animationImages = animationImages;
        this.wrapperElement = wrapperElement;
        this.veilDiv = document.getElementById("selectionVeil");
        this.animationDiv = document.getElementById("veilAnimation");
        this.textDiv = document.getElementById("veilText");
        disableTextSelection(this.animationDiv);
        disableTextSelection(this.textDiv);
    }

    startAnimation()
    {
        this.imageIdx = 0;
        var self = this;
        var doAnimate = function()
        {
            self.nextAnimationImage();
            self.animationTid = setTimeout(doAnimate, 100);
        };
        doAnimate();
    }

    nextAnimationImage()
    {
        var imgSrc = this.animationImages[this.imageIdx];
        this.animationDiv.style.backgroundImage = 'url(' + imgSrc + ')';
        this.imageIdx++;
        if (this.imageIdx == this.animationImages.length)
            this.imageIdx = 0;
    }

    stopAnimation()
    {
        if (this.animationTid)
        {
            clearTimeout(this.animationTid);
            this.animationTid = undefined;
        }
    }

    showOver(selection, text)
    {
        var topLeftCell = selection.getTopLeftVisibleCell();
        var bottomRightCell = selection.getBottomRightVisibleCell();
        var topLeftTdPos = calculateObjectCoords(topLeftCell.getCellEl());
        var bottomRightTdPos = calculateObjectCoords(bottomRightCell.getCellEl());
        var wrapperElementPos = this.wrapperElement ? calculateObjectCoords(this.wrapperElement) : {x: 0, y: 0};

        this.veilDiv.style.left = topLeftTdPos.x - wrapperElementPos.x + "px";
        this.veilDiv.style.top = topLeftTdPos.y - wrapperElementPos.y + "px";

        this.veilDiv.style.width = (bottomRightTdPos.x - topLeftTdPos.x + bottomRightCell.getCellEl().clientWidth + 2) + "px";
        var height = bottomRightTdPos.y - topLeftTdPos.y + bottomRightCell.getCellEl().clientHeight + 1;
        this.veilDiv.style.height = height + "px";

        var showText = (text != null) && (topLeftCell.getRow().getRowIdx() < bottomRightCell.getRow().getRowIdx());
        var contentHeight = 23;//animation height
        if (showText)
        {
            this.textDiv.innerHTML = text;
            this.textDiv.style.display = "block";
            contentHeight += 12;//text height
        }
        else
        {
            this.textDiv.style.display = "none";
        }

        this.animationDiv.style.marginTop = ((height - contentHeight) / 2) + "px";

        this.startAnimation();
        this.veilDiv.style.display = "block";
    }

    hide()
    {
        this.stopAnimation();
        this.veilDiv.style.display = "none";
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/SelectionVeil.js